<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-03-03 18:53:02
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>保安详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTab">
        <div style="text-align: right; margin-bottom: 10px">
          <el-button type="primary" @click="edit()" v-if="pageStatus == 0"
            >编辑</el-button
          >
          <div v-else>
            <el-button @click="pageStatus = 0">取消</el-button>
            <el-button type="primary" @click="edit()">保存</el-button>
          </div>
        </div>
        <div class="solidBox">
          <div class="modelTitle">
            <div style="display: flex; align-items: center">
              <img
                :src="detail.headimgUrl || require('@/assets/imgs/headImg.png')"
                alt=""
                style="width: 30px; height: 30px; margin-right: 10px"
              />
              {{
                detail.accountType == 0
                  ? "企业"
                  : detail.accountType == 1
                  ? "企业员工"
                  : "临勤"
              }}信息
            </div>
          </div>
          <div v-if="detail.accountType == 0 && pageStatus == 0">
            <div style="display: flex; justify-content: space-between">
              <div style="width: 75%">
                <div class="modelDetail">
                  <div class="infoItem">公司名称：{{ detail.companyName }}</div>
                  <div class="infoItem">手机号：{{ detail.phone }}</div>
                  <div class="infoItem">
                    统一社会信用代码：{{ detail.licenseNo }}
                  </div>
                  <div class="infoItem">
                    注册地址：{{ detail.registerAddress }}
                  </div>
                  <div class="infoItem">
                    注册资金：{{ detail.registeredCapital }}万
                  </div>
                  <div class="infoItem">
                    经营范围：{{ detail.businessScope }}
                  </div>
                </div>
                <div class="modelDetail" style="display: flex; flex-wrap: wrap">
                  <!-- <div class="infoItem">所属省：{{ detail.orgProvince }}</div>
                  <div class="infoItem">所属市：{{ detail.orgCity }}</div>
                  <div class="infoItem">所属区：{{ detail.orgArea }}</div>
                  <div class="infoItem">所属街道：{{ detail.orgStreet }}</div> -->
                  <div class="infoItem">
                    监管部门：<span
                      v-for="item in detail.sysOrgList"
                      :key="item"
                      style="margin-right: 10px"
                      >{{ item.name }}</span
                    >
                  </div>
                </div>
              </div>
              <el-image
                class="avatar"
                v-if="detail.businessLicense && detail.businessLicense != ''"
                :src="detail.businessLicense"
                alt=""
                :preview-src-list="[detail.businessLicense]"
              >
              </el-image>
            </div>
          </div>
          <div v-if="detail.accountType != 0 && pageStatus == 0">
            <div class="modelDetail">
              <div class="infoItem">
                姓名：{{ detail.cardName || detail.nickname }}
              </div>
              <div class="infoItem">民族：{{ detail.nationality }}</div>
              <div class="infoItem">手机号：{{ detail.phone }}</div>
              <div class="infoItem">身份证：{{ detail.cardCode }}</div>
              <div class="infoItem">
                性别：{{ detail.sex == 1 ? "男" : detail.sex == 2 ? "女" : "" }}
              </div>
              <!-- <div class="infoItem">年龄：{{ age }}岁</div> -->
              <div class="infoItem">身高：{{ detail.high }}cm</div>
              <div class="infoItem">体重：{{ detail.weight }}公斤</div>
              <div class="infoItem">出生日期：{{ detail.birthday }}</div>
              <div class="infoItem">家庭住址：{{ detail.address }}</div>
              <!-- <div class="infoItem" v-if="detail.bodyguardCerts">
                职业：<span
                  v-for="(item, index) in detail.bodyguardCerts"
                  :key="index"
                  >{{ item.careerTypeName }}-{{ item.levelTypeName
                  }}<span v-if="detail.bodyguardCerts.length > 1">/</span></span
                >
              </div> -->
              <!-- <span v-for="(item, index) in detail.bodyguardCerts" :key="index">
                <div
                  class="infoItem"
                  v-if="
                    item.careerType == 1 && detail.bodyguardCerts.length > 1
                  "
                >
                  保安号：{{ item.certNumber }}
                </div>
              </span>
              <span v-for="(item, index) in detail.bodyguardCerts" :key="index">
                <div
                  class="infoItem"
                  v-if="
                    item.careerType == 2 && detail.bodyguardCerts.length > 1
                  "
                >
                  消防中控号：{{ item.certNumber }}
                </div>
              </span> -->
            </div>
            <div class="infoItem">
              <el-image
                class="avatar"
                v-if="detail.cardFrontUrl && detail.cardFrontUrl != ''"
                :src="detail.cardFrontUrl"
                alt=""
                :preview-src-list="[detail.cardFrontUrl]"
              >
              </el-image>
              <el-image
                class="avatar"
                v-if="detail.cardBackUrl && detail.cardBackUrl != ''"
                :src="detail.cardBackUrl"
                alt=""
                :preview-src-list="[detail.cardBackUrl]"
                style="margin: 0 20px"
              >
              </el-image>
              <el-image
                class="avatar"
                v-if="detail.guardLicenseUrl && detail.guardLicenseUrl != ''"
                :src="detail.guardLicenseUrl"
                alt=""
                :preview-src-list="[detail.guardLicenseUrl]"
              >
              </el-image>
              <!-- <img
              :src="
                detail.bodyguardCerts[0]
                  ? detail.bodyguardCerts[0].certFrontUrl
                  : ''
              "
              alt=""
              v-if="
                detail.bodyguardCerts[0] &&
                  detail.bodyguardCerts[0].certFrontUrl != ''
              "
            /> -->
            </div>
          </div>
        </div>
        <div class="solidBox" v-if="detail.accountType == 0 && pageStatus == 0">
          <div class="modelTitle">保安服务许可证信息</div>
          <div
            class="modelDetail"
            style="display: flex; justify-content: space-between"
          >
            <div style="display: flex; flex-wrap: wrap; width: 75%">
              <div class="infoItem">
                许可证编号：{{ detail.serviceLicenseNumber }}
              </div>
              <div class="infoItem">服务范围：{{ detail.gscScope }}</div>
            </div>
            <el-image
              class="avatar"
              v-if="detail.guardLicenseUrl && detail.guardLicenseUrl != ''"
              :src="detail.guardLicenseUrl"
              alt=""
              :preview-src-list="[detail.guardLicenseUrl]"
            >
            </el-image>
          </div>
        </div>
        <div class="solidBox" v-if="detail.accountType == 0 && pageStatus == 0">
          <div class="modelTitle">法人信息</div>
          <div
            class="modelDetail"
            style="display: flex; justify-content: space-between"
          >
            <div style="display: flex; flex-wrap: wrap; width: 65%">
              <div class="infoItem">
                姓名：{{ detail.legalPersonResp.name }}
              </div>
              <div class="infoItem">
                民族：{{ detail.legalPersonResp.nationality }}
              </div>
              <div class="infoItem">
                性别：{{ detail.legalPersonResp.sex == 1 ? "男" : "女" }}
              </div>
              <div class="infoItem">
                出生年月：{{ detail.legalPersonResp.birthday }}
              </div>
              <div class="infoItem">
                证件有效期：{{ detail.legalPersonResp.cardValidityStart }}-{{
                  detail.legalPersonResp.cardValidityEnd
                }}
              </div>
              <div class="infoItem">
                签发机关：{{ detail.legalPersonResp.issuingAuthority }}
              </div>
              <div class="infoItem">
                地址：{{ detail.legalPersonResp.currentAddress }}
              </div>
            </div>
            <div>
              <el-image
                style="width: 150px; height: 100px"
                :src="detail.legalPersonResp.cardPhotoFront"
                alt=""
                :preview-src-list="[detail.legalPersonResp.cardPhotoFront]"
              ></el-image>
              <el-image
                style="width: 150px; height: 100px"
                :src="detail.legalPersonResp.cardPhotoBack"
                alt=""
                :preview-src-list="[detail.legalPersonResp.cardPhotoBack]"
              ></el-image>
            </div>
          </div>
        </div>
        <div v-if="pageStatus == 1" style="margin-top: 20px">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <div v-if="detail.accountType == 0">
              <el-form-item
                label="统一社会信用代码"
                prop="num"
                label-width="150"
              >
                <el-input v-model="ruleForm.num"></el-input>
              </el-form-item>
              <el-form-item label="注册地址" prop="address">
                <el-input v-model="ruleForm.address"></el-input>
              </el-form-item>
              <el-form-item label="法人姓名" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>
              <!-- <el-form-item label="营业执照" prop="status">
                <el-radio-group v-model="ruleForm.status">
                  <el-radio :label="0">未审核</el-radio>
                  <el-radio :label="1">已审核</el-radio>
                </el-radio-group>
              </el-form-item> -->
              <el-form-item label="营业执照照片" prop="img">
                <div style="position: relative">
                  <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :headers="deader"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                  >
                    <img
                      v-if="ruleForm.img"
                      :src="ruleForm.img"
                      class="avatar"
                      style="width: 100px"
                    />
                    <div class="modelView1" v-if="ruleForm.img">编辑</div>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item
                label="保安服务许可证"
                prop="img3"
                label-width="150"
              >
                <div style="position: relative">
                  <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :headers="deader"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess3"
                  >
                    <img
                      v-if="ruleForm.img3"
                      :src="ruleForm.img3"
                      class="avatar"
                      style="width: 100px"
                    />
                    <div class="modelView1" v-if="ruleForm.img3">编辑</div>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </el-form-item>
            </div>
            <div v-if="detail.accountType == 2 || detail.accountType == 1">
              <el-form-item label="姓名" prop="cardName">
                <el-input v-model="ruleForm.cardName"></el-input>
              </el-form-item>
              <el-form-item label="身份证号码" prop="idNum">
                <el-input v-model="ruleForm.idNum"></el-input>
              </el-form-item>
              <el-form-item label="性别" prop="sex">
                <el-select v-model="ruleForm.sex" placeholder="请选择">
                  <el-option label="未知" value="0"> </el-option>
                  <el-option label="男" value="1"> </el-option>
                  <el-option label="女" value="2"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="出生年月" prop="year">
                <el-date-picker
                  v-model="ruleForm.year"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="家庭住址" prop="address1">
                <el-input v-model="ruleForm.address1"></el-input>
              </el-form-item>
              <el-form-item label="身高" prop="high">
                <el-input v-model="ruleForm.high" type="number"></el-input>
              </el-form-item>
              <el-form-item label="体重" prop="weight">
                <el-input v-model="ruleForm.weight" type="number"></el-input>
              </el-form-item>
              <!-- <el-form-item label="保安证审核" prop="status">
                <el-radio-group v-model="ruleForm.status">
                  <el-radio :label="0">未审核</el-radio>
                  <el-radio :label="1">已审核</el-radio>
                </el-radio-group>
              </el-form-item> -->
              <!-- <el-form-item label="身份证审核" prop="status1">
                <el-radio-group v-model="ruleForm.status1">
                  <el-radio :label="0">未审核</el-radio>
                  <el-radio :label="1">已审核</el-radio>
                </el-radio-group>
              </el-form-item> -->
              <!-- <el-form-item label="保安执照号" prop="certNumber">
                <el-input v-model="ruleForm.certNumber"></el-input>
              </el-form-item> -->
              <el-form-item label="保安证书编号" prop="certNumber1">
                <el-input v-model="ruleForm.certNumber1"></el-input>
              </el-form-item>
              <el-form-item
                label="身份证照片（正面）"
                prop="img1"
                label-width="150"
              >
                <div style="position: relative">
                  <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :headers="deader"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess1"
                    style="width: 200px; height: 200px"
                  >
                    <img
                      v-if="ruleForm.img1"
                      :src="ruleForm.img1"
                      class="avatar"
                      style="width: 200px; height: 200px"
                    />
                    <div class="modelView" v-if="ruleForm.img1">编辑</div>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item
                label="身份证照片（反面）"
                prop="img2"
                label-width="170"
              >
                <div style="position: relative">
                  <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :headers="deader"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess2"
                    style="width: 200px; height: 200px"
                  >
                    <img
                      v-if="ruleForm.img2"
                      :src="ruleForm.img2"
                      class="avatar"
                      style="width: 200px; height: 200px"
                    />
                    <div class="modelView" v-if="ruleForm.img2">编辑</div>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item label="保安证照片" prop="img">
                <div style="position: relative">
                  <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :headers="deader"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess9"
                    style="width: 200px; height: 200px"
                  >
                    <img
                      v-if="ruleForm.certFrontUrl != ''"
                      :src="ruleForm.certFrontUrl"
                      class="avatar"
                      style="width: 200px; height: 200px"
                    />
                    <div class="modelView" v-if="ruleForm.certFrontUrl">
                      编辑
                    </div>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="modelTitle" style="margin-top: 30px">账号信息</div>
        <div class="modelDetail">
          <!-- <div class="infoItem">等级：{{ detail.accountLevel }}</div> -->
          <div class="infoItem">保安证号码：{{ detail.bodyguardCardCode }}</div>
          <div class="infoItem">
            保安证编号：{{
              detail.bodyguardCerts && detail.bodyguardCerts[0]
                ? detail.bodyguardCerts[0].certNumber
                : ""
            }}
          </div>
          <div class="infoItem">创建时间：{{ detail.gmtCreate }}</div>
          <!-- <div class="infoItem">等级积分：{{ detail.levelExperience }}分</div> -->
          <div class="infoItem">支付宝账号：{{ detail.alipayCode }}</div>
          <!-- <div class="infoItem">微信号：{{ detail.wechatCode }}</div> -->
          <div class="infoItem">充值金额：￥{{ detail.rechargeAmount }}</div>
          <div class="infoItem">余额：￥{{ detail.balanceAmount }}</div>
          <!-- <div class="infoItem">违约金额：￥{{ detail.defaultAmount }}</div> -->
          <div class="infoItem">违约次数：{{ detail.failedJobs }}</div>
          <div class="infoItem">任务次数：{{ detail.jobsTotal }}</div>
          <div class="infoItem">预期收益：{{ detail.frozenAmount }}</div>
          <div class="infoItem">平台奖励金额：{{ detail.redPacketAmount }}</div>
          <div class="infoItem">任务金额：{{ detail.taskAmount }}</div>
          <!-- <div class="infoItem">红包金额：￥{{ detail.redPacketAmount }}</div> -->
          <div class="infoItem">
            手机品牌：{{
              detail.lastPhoneBrand ? detail.lastPhoneBrand : "null"
            }}
          </div>
          <div class="infoItem">
            手机型号：{{
              detail.lastPhoneModel ? detail.lastPhoneModel : "null"
            }}
          </div>
          <div class="infoItem">
            手机系统号：{{
              detail.lastPhoneSystemVersion
                ? detail.lastPhoneSystemVersion
                : "null"
            }}
          </div>
          <div class="infoItem">
            最近登录地址：{{
              detail.lastLoginAddress ? detail.lastLoginAddress : ""
            }}
          </div>
          <div class="infoItem">
            最近登录省份：{{
              detail.lastLoginProvince ? detail.lastLoginProvince : ""
            }}
          </div>
          <div class="infoItem">
            最近登录城市：{{ detail.lastLoginCity ? detail.lastLoginCity : "" }}
          </div>
          <div class="infoItem">
            最近登录地区：{{ detail.lastLoginArea ? detail.lastLoginArea : "" }}
          </div>
          <div class="infoItem">
            最近登录时间：{{ detail.lastLoginTime ? detail.lastLoginTime : "" }}
          </div>
          <div class="infoItem">
            当前App版本号：{{ detail.versionNo ? detail.versionNo : "null" }}
          </div>
          <div class="infoItem">
            邀请人：{{ detail.inviteName
            }}<span v-if="detail.invitePhone && detail.invitePhone != ''"
              >({{ detail.invitePhone }})</span
            >
          </div>
        </div>
        <div
          class="modelTitle"
          style="margin-top: 30px"
          v-if="detail.bodyguardCerts && detail.bodyguardCerts.length > 0"
        >
          证件信息
        </div>
        <div
          class="modelDetail"
          style="margin-top: 20px"
          v-if="detail.bodyguardCerts && detail.bodyguardCerts.length > 0"
        >
          <div
            v-for="(item, index) in detail.bodyguardCerts"
            :key="index"
            class="item"
            style="text-align: left; color: #000; margin-bottom: 10px"
          >
            <el-image
              class="avatar"
              v-if="item.certFrontUrl"
              :src="item.certFrontUrl"
              alt=""
              :preview-src-list="[item.certFrontUrl]"
            >
            </el-image>
            <el-image
              class="avatar"
              v-if="item.certOppositeUrl"
              :src="item.certOppositeUrl"
              alt=""
              :preview-src-list="[item.certOppositeUrl]"
            >
            </el-image>
            <div>证件名称：{{ item.certNumber }}</div>
            <div>
              审核状态：{{
                item.verifyStatus == 0
                  ? "未通过"
                  : item.verifyStatus == 1
                  ? "通过"
                  : "待审核"
              }}
            </div>
            <div>
              证件类型/证件等级：{{ item.careerTypeName }}/{{
                item.levelTypeName
              }}
            </div>
          </div>
        </div>
        <div
          class="solidBox"
          v-if="
            detail.accountType != 0 &&
            detail.xwbankStatus == 1 &&
            detail.memberBanksVO
          "
          style="margin-top: 20px"
        >
          <div class="modelTitle">个人开户信息</div>
          <div class="modelDetail" style="display: flex">
            <div>
              <div class="infoItem">姓名：{{ detail.cardName }}</div>
              <div class="infoItem">地址：{{ detail.address }}</div>
              <div class="infoItem">身份证号：{{ detail.cardCode }}</div>
              <div class="infoItem">
                银行卡号：{{ detail.memberBanksVO.bankAccountNo }}
              </div>
              <div class="infoItem">
                开户行名称：{{ detail.memberBanksVO.bankFullName }}
              </div>
              <div class="infoItem">手机号码：{{ detail.phone }}</div>
              <div class="infoItem">
                职业：{{ detail.individualVocationName }}
              </div>
            </div>
            <div style="margin-left: 50px">
              <div style="margin-bottom: 20px">身份证照片</div>
              <el-image
                style="width: 150px; height: 100px"
                :src="detail.cardFrontUrl"
                alt=""
                :preview-src-list="[detail.cardFrontUrl]"
              ></el-image>
              <el-image
                style="width: 150px; height: 100px"
                :src="detail.cardBackUrl"
                alt=""
                :preview-src-list="[detail.cardBackUrl]"
              ></el-image>
            </div>
          </div>
        </div>

        <div
          class="solidBox"
          v-if="
            detail.accountType == 0 &&
            detail.xwbankStatus == 1 &&
            detail.companyInfo
          "
          style="margin-top: 20px"
        >
          <div class="modelTitle">企业开户信息</div>
          <div
            class="modelDetail"
            style="display: flex; justify-content: space-between"
          >
            <div style="width: 30%">
              <div>
                <div style="margin: 20px 0">营业执照照片</div>
                <el-image
                  style="width: 150px; height: 100px"
                  :src="detail.companyInfo.businessLicense"
                  alt=""
                  :preview-src-list="[detail.companyInfo.businessLicense]"
                ></el-image>
              </div>
              <div class="infoItem">
                企业全称：{{ detail.companyInfo.companyName }}
              </div>
              <div class="infoItem">
                经营证件类型：{{ detail.companyInfo.enterpriseLicenseName }}
              </div>
              <div class="infoItem">
                营业执照号码：{{ detail.companyInfo.licenseNo }}
              </div>
              <div class="infoItem">
                行业代码：{{ detail.companyInfo.enterpriseTrade }}
              </div>
              <div class="infoItem">
                企业实际经营地址：{{ detail.companyInfo.enterpriseRealAddress }}
              </div>
              <div class="infoItem">
                企业对公户开户行名称：{{ detail.companyInfo.bankName }}
              </div>
              <div class="infoItem">
                企业对公户开户行号：{{ detail.companyInfo.bankAccountNo }}
              </div>
              <div class="infoItem">
                企业对公账户号：{{ detail.companyInfo.enterpriseBankCardNo }}
              </div>
            </div>
            <div style="width: 30%">
              <div>
                <div style="margin: 20px 0">法人身份证照片</div>
                <el-image
                  style="width: 150px; height: 100px"
                  :src="
                    JSON.parse(detail.companyInfo.legalPerson).cardPhotoFront
                  "
                  alt=""
                  :preview-src-list="[
                    JSON.parse(detail.companyInfo.legalPerson).cardPhotoFront,
                  ]"
                ></el-image>
                <el-image
                  style="width: 150px; height: 100px"
                  :src="
                    JSON.parse(detail.companyInfo.legalPerson).cardPhotoBack
                  "
                  alt=""
                  :preview-src-list="[
                    JSON.parse(detail.companyInfo.legalPerson).cardPhotoBack,
                  ]"
                ></el-image>
              </div>
              <div class="infoItem">
                法人姓名：{{ JSON.parse(detail.companyInfo.legalPerson).name }}
              </div>
              <div class="infoItem">法人证件类型：身份证</div>
              <div class="infoItem">
                法人身份证号：{{
                  JSON.parse(detail.companyInfo.legalPerson).cardNo
                }}
              </div>
              <div class="infoItem">
                法人手机号：{{
                  JSON.parse(detail.companyInfo.legalPerson).contactInformation
                }}
              </div>
              <div class="infoItem">
                企业控股股东名称：{{
                  JSON.parse(detail.companyInfo.enterpriseShareholderInfo)[0]
                    .enterpriseShareholderName
                }}
              </div>
              <div class="infoItem">企业控股股东证件类型：身份证</div>
              <div class="infoItem">
                企业控股股东证件号码：{{
                  JSON.parse(detail.companyInfo.enterpriseShareholderInfo)[0]
                    .enterpriseShareholderIdCardNo
                }}
              </div>
              <div class="infoItem">
                企业控股股东证件起始日期：{{
                  JSON.parse(detail.companyInfo.enterpriseShareholderInfo)[0]
                    .enterpriseShareholderIdCardValidStartDate
                }}
              </div>
              <div class="infoItem">
                企业控投股东证件截止日期：{{
                  JSON.parse(detail.companyInfo.enterpriseShareholderInfo)[0]
                    .enterpriseShareholderIdCardValidDate
                }}
              </div>
            </div>
            <div style="width: 30%">
              <div>
                <div style="margin: 20px 0">联系人身份证照片</div>
                <el-image
                  style="width: 150px; height: 100px"
                  :src="
                    JSON.parse(detail.companyInfo.contactInfo).cardPhotoFront
                  "
                  alt=""
                  :preview-src-list="[
                    JSON.parse(detail.companyInfo.contactInfo).cardPhotoFront,
                  ]"
                ></el-image>
                <el-image
                  style="width: 150px; height: 100px"
                  :src="
                    JSON.parse(detail.companyInfo.contactInfo).cardPhotoBack
                  "
                  alt=""
                  :preview-src-list="[
                    JSON.parse(detail.companyInfo.contactInfo).cardPhotoBack,
                  ]"
                ></el-image>
              </div>
              <div class="infoItem">
                联系人姓名：{{
                  JSON.parse(detail.companyInfo.contactInfo).name
                }}
              </div>
              <div class="infoItem">联系人证件类型：身份证</div>
              <div class="infoItem">
                联系人身份证号：{{
                  JSON.parse(detail.companyInfo.contactInfo).cardNo
                }}
              </div>
              <div class="infoItem">
                联系人手机号：{{
                  JSON.parse(detail.companyInfo.contactInfo).contactInformation
                }}
              </div>
              <div class="infoItem">
                企业最终受益人名称：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryName
                }}
              </div>
              <div class="infoItem">
                企业最终受益人证件类型：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryIdCardType == "B01"
                    ? "身份证"
                    : JSON.parse(
                        detail.companyInfo.enterpriseBeneficiaryInfos
                      )[0].enterpriseBeneficiaryIdCardType == "B04"
                    ? "护照"
                    : "营业执照"
                }}
              </div>
              <div class="infoItem">
                企业最终受益人证件号码：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryIdCardNo
                }}
              </div>
              <div class="infoItem">
                企业最终受益人联系电话：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryIdContactPhone
                }}
              </div>
              <div class="infoItem">
                企业最终受益人证件起始日期：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryIdCardValidStartDate
                }}
              </div>
              <div class="infoItem">
                企业最终受益人证件截止日期：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryIdCardValidDate
                }}
              </div>
              <div class="infoItem">
                企业最终受益人联系地址：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryAddress
                }}
              </div>
              <div class="infoItem">
                企业最终受益人受益方式：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryShareRatio == "A01"
                    ? "直接或间接控股25%（含）以上"
                    : JSON.parse(
                        detail.companyInfo.enterpriseBeneficiaryInfos
                      )[0].enterpriseBeneficiaryShareRatio == "A02"
                    ? "通过人事、财务等其他方式对公司进行控制"
                    : JSON.parse(
                        detail.companyInfo.enterpriseBeneficiaryInfos
                      )[0].enterpriseBeneficiaryShareRatio == "A03"
                    ? "高级管理人员"
                    : JSON.parse(
                        detail.companyInfo.enterpriseBeneficiaryInfos
                      )[0].enterpriseBeneficiaryShareRatio == "A04"
                    ? "法人或公司负责人"
                    : "其他"
                }}
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="modelTitle" style="margin-top: 30px;">用户标签</div>
        <div class="modelDetail" style="margin-top: 20px;">
          <div
            v-for="(item, index) in detail.tagsList"
            :key="index"
            class="item all"
          >
            {{ item.name }}
          </div>
          <el-button type="primary" @click="addTag()"
            >添加<i class="el-icon-plus"></i
          ></el-button>
        </div> -->
        <div class="modelTitle" style="margin-top: 30px">记录列表</div>
        <div style="margin-top: 30px">
          <el-tabs type="border-card" @tab-click="handleClick">
            <el-tab-pane label="任务记录"
              ><el-table
                ref="scrollTable"
                :data="tableData"
                border
                style="width: 100%"
              >
                <el-table-column
                  prop="jobNo"
                  label="任务编号"
                  align="center"
                  width="150"
                >
                </el-table-column>
                <el-table-column
                  prop="customName"
                  label="发布人名"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="customPhone"
                  label="手机号"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="inviteAmount"
                  label="邀请收益"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="jobName"
                  label="任务名称"
                  align="center"
                  width="180"
                >
                </el-table-column>
                <!-- <el-table-column label="任务类型" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.type == 1"> 普通任务 </span>
                  </template>
                </el-table-column> -->
                <el-table-column label="要求身高" align="center">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.high == 0 ? "不限" : scope.row.high
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="membersNum"
                  label="要求人数"
                  align="center"
                >
                </el-table-column>
                <el-table-column label="单价" align="center">
                  <template slot-scope="scope">
                    <span>￥{{ scope.row.unitPrice }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="总计" align="center">
                  <template slot-scope="scope">
                    <span>￥{{ scope.row.price }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="状态" align="center" width="130">
                  <template slot-scope="scope">
                    <span class="blueColor" v-if="scope.row.workStatus == 1"
                      >未开始</span
                    >
                    <span class="blueColor" v-if="scope.row.workStatus == 2"
                      >工作中</span
                    >
                    <span class="blueColor" v-if="scope.row.workStatus == 3"
                      >已完成</span
                    >
                    <span class="blueColor" v-if="scope.row.workStatus == 4"
                      >已结算</span
                    >
                    <span class="greenColor" v-if="scope.row.workStatus == 5"
                      >已取消</span
                    >
                    <span class="greenColor" v-if="scope.row.workStatus == 6"
                      >已开除(未结算)</span
                    >
                    <span class="greenColor" v-if="scope.row.workStatus == 7"
                      >已开除(已结算)</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  label="创建/完成时间"
                  align="center"
                  width="150"
                >
                  <template slot-scope="scope">
                    <div>{{ scope.row.actionAt }}</div>
                    <div>{{ scope.row.jobEnd }}</div>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <!-- <el-tab-pane label="充值记录"
              ><el-table ref="scrollTable":data="tableData" border style="width: 100%">
                <el-table-column prop="id" label="编号" align="center">
                </el-table-column>
                <el-table-column
                  prop="creditAmount"
                  label="充值金额"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="" label="充值类型" align="center">
                </el-table-column>
                <el-table-column label="状态" align="center">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.status == 0 ? "未确认" : "已确认"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="payAt" label="交易时间" align="center">
                </el-table-column>
              </el-table>
            </el-tab-pane> -->
            <el-tab-pane label="违约记录"
              ><el-table
                ref="scrollTable"
                :data="tableData"
                border
                style="width: 100%"
              >
                <el-table-column prop="violateLogNo" label="编号" width="180">
                </el-table-column>
                <el-table-column prop="jobTitle" label="任务名称" width="180">
                </el-table-column>
                <el-table-column prop="violateRuleId" label="触发规则">
                </el-table-column>
                <el-table-column prop="violateAmount" label="违约金额">
                </el-table-column>
                <el-table-column prop="violateAt" label="违约时间">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <!-- <el-tab-pane label="登录记录"
              ><el-table
                ref="scrollTable"
                :data="tableData"
                border
                style="width: 100%"
              >
                <el-table-column prop="id" label="编号" width="180">
                </el-table-column>
                <el-table-column prop="ip" label="ip" width="180">
                </el-table-column>
                <el-table-column prop="address" label="所在地">
                </el-table-column>
                <el-table-column prop="gmtCreate" label="登录时间">
                </el-table-column>
              </el-table>
            </el-tab-pane> -->
            <el-tab-pane label="钱包明细">
              <el-button
                type="primary"
                @click="exportList()"
                class="btn"
                style="margin-bottom: 10px"
                >导出</el-button
              ><el-table
                ref="scrollTable"
                :data="tableData"
                border
                style="width: 100%"
              >
                <el-table-column
                  prop="billDetailNo"
                  label="帐单编号"
                  width="130"
                >
                </el-table-column>
                <el-table-column label="保安姓名" width="130">
                  <template slot-scope="scope">
                    <span>{{ detail.cardName || detail.nickname }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="jobNo" label="任务编号" width="130">
                </el-table-column>
                <el-table-column prop="jobName" label="任务名称" width="130">
                </el-table-column>
                <!-- <el-table-column prop="channelType" label="支付方式">
                  <template slot-scope="scope">
                    <span v-if="scope.row.channelType == 0">钱包</span>
                    <span v-if="scope.row.channelType == 1">对公转账</span>
                    <span v-if="scope.row.channelType == 2">银行卡</span>
                    <span v-if="scope.row.channelType == 3">支付宝</span>
                    <span v-if="scope.row.channelType == 4">微信</span>
                  </template>
                </el-table-column> -->
                <el-table-column label="变动类型">
                  <template slot-scope="scope">
                    <span>{{ scope.row.changeName }}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="变动类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.changeType == 0">充值</span>
                    <span v-if="scope.row.changeType == 1">冻结</span>
                    <span v-if="scope.row.changeType == 2">解冻</span>
                    <span v-if="scope.row.changeType == 3">提现</span>
                    <span v-if="scope.row.changeType == 4">违约扣款</span>
                    <span v-if="scope.row.changeType == 5">任务结算</span>
                    <span v-if="scope.row.changeType == 6">违约扣款取消</span>
                    <span v-if="scope.row.changeType == 7">邀请收入</span>
                    <span v-if="scope.row.changeType == 8">投诉赔偿</span>
                    <span v-if="scope.row.changeType == 9">投诉补偿</span>
                    <span v-if="scope.row.changeType == 10">任务创建</span>
                  </template>
                </el-table-column> -->
                <el-table-column prop="changeAmount" label="变动金额">
                  <template slot-scope="scope">
                    {{ scope.row.changeTo == 0 ? "+" : "-"
                    }}{{
                      scope.row.changeType == 3
                        ? scope.row.changeAmount
                        : scope.row.actualAmount
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="taxAmount" label="税费(元)">
                </el-table-column>
                <el-table-column prop="channelName" label="支付方式">
                </el-table-column>
                <el-table-column
                  prop="thirdPaymentOrder"
                  label="第三方流水号"
                  width="130"
                >
                </el-table-column>
                <el-table-column
                  prop="paymentOrder"
                  label="平台支付单号"
                  width="130"
                >
                </el-table-column>
                <el-table-column prop="changeAmount" label="支付状态">
                  <template slot-scope="scope">
                    <span>{{ scope.row.statusName }}</span>
                  </template>
                </el-table-column>

                <el-table-column prop="paymentAt" label="支付时间" width="130">
                </el-table-column>
                <el-table-column prop="gmtCreate" label="创建时间" width="130">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="绑定银行卡"
              ><el-table
                ref="scrollTable"
                :data="tableData"
                border
                style="width: 100%"
              >
                <el-table-column prop="memberName" label="姓名" width="180">
                </el-table-column>
                <el-table-column prop="bankFullName" label="开户行" width="180">
                </el-table-column>
                <el-table-column prop="bankName" label="银行简称">
                </el-table-column>
                <el-table-column prop="bankAccountNo" label="银行卡号">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize"
              layout="total, prev, pager, next,sizes"
              :total="total"
            >
            </el-pagination>
          </el-tabs>
        </div>
      </div>
      <el-dialog
        title="用户标签"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <div class="tagList">
          <div
            v-for="(item, index) in tagsList"
            :key="index"
            :class="['item', item.isSelect == '1' ? 'select' : '']"
            @click="selectTag(item)"
          >
            {{ item.name }}
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="confrimTag()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
import axiosUrl from "../../api/axios.js";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.askariData(),
      editId: "",
      tableData: [],
      age: 0,
      year: 0,
      detail: {},
      pageSize: 10,
      page: 1,
      total: 0,
      selectIndex: 0, //记录列表选中的下标
      pageStatus: 0,
      ruleForm: {
        name1: "",
        phone: "",
        money: "",
        fanwei: "",
        address: "",
        name: "",
        num: "",
        num1: "",
        img: "",
        img1: "",
        img3: "",
        idNum: "",
        sex: "",
        year: "",
        address1: "",
        img2: "",
        high: "",
        weight: "",
        bodyguardCardCode: "",
        status: 0,
        status1: 0,
        bodyguardCard: "",
        certFrontUrl: "",
        certNumber: "",
        certNumber1: "",
      },
      deader: {
        "x-ba-admin-token": localStorage.getItem("TOKEN"),
      },
      rules: {
        num: [{ required: true, message: "必填项", trigger: "blur" }],
        idNum: [
          { required: true, message: "必填项", trigger: "blur" },
          {
            pattern: /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/,
            message: "请填写正确的身份证号码",
            trigger: "blur",
          },
        ],
        sex: [{ required: true, message: "必选项", trigger: "change" }],
        year: [{ required: true, message: "必填项", trigger: "blur" }],
        address1: [{ required: true, message: "必填项", trigger: "blur" }],
        // img1: [{ required: true, message: "必填项", trigger: "blur" }],
        img3: [{ required: true, message: "必填项", trigger: "blur" }],
        // img2: [{ required: true, message: "必填项", trigger: "blur" }],
        high: [{ required: true, message: "必填项", trigger: "blur" }],
        weight: [{ required: true, message: "必填项", trigger: "blur" }],
        // certNumber: [{ required: true, message: "必填项", trigger: "blur" }],
        certNumber1: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      dialogVisible: false,
      tagsList: [],
      uploadUrl: "",
      canConfrim: true,
    };
  },
  mounted() {
    this.uploadUrl = axiosUrl.defaults.baseURL + "admapi/sys/file/upload";
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.getDetail();
      this.getlist();
    }
    this.year = new Date().getFullYear();
  },
  methods: {
    exportList() {
      this.$confirm("是否导出数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(
              "/admapi/bodyguard/billdetailexport",
              { userId: this.editId },
              {
                responseType: "blob",
              }
            )
            .then((data) => {
              console.log(data);
              let val = new Blob([data.data], {
                type: "application/vnd.ms-excel;charset=utf-8",
              });
              let header = decodeURI(data.headers["content-disposition"]);
              console.log(header);
              let index = header.indexOf("''");
              let fileName = header.substring(index + 2, header.length);
              const url = window.URL.createObjectURL(val);
              const link = document.createElement("a");
              link.download = fileName; // 设置a标签的下载属性
              link.style.display = "none";
              link.href = url;
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(link.href); // 下载完成释放URL 对象
              document.body.removeChild(link);
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    handleAvatarSuccess(res) {
      this.ruleForm.img = res.data;
    },
    handleAvatarSuccess9(res) {
      this.ruleForm.certFrontUrl = res.data;
    },
    handleAvatarSuccess1(res) {
      this.ruleForm.img1 = res.data;
    },
    handleAvatarSuccess2(res) {
      this.ruleForm.img2 = res.data;
    },
    handleAvatarSuccess3(res) {
      this.ruleForm.img3 = res.data;
    },
    edit(ruleForm) {
      if (this.canConfrim == true) {
        if (this.pageStatus == 0) {
          this.pageStatus = 1;
        } else {
          if (this.detail.accountType == 0) {
            if (this.ruleForm.num == "") {
              this.$message({
                message: "请填写必填项",
                type: "warning",
              });
              return;
            } else {
              this.canConfrim = false;
              let param = {
                licenseNo: this.ruleForm.num,
                companyAddress: this.ruleForm.address,
                corporateName: this.ruleForm.name,
                taxNo: this.ruleForm.num1,
                businessLicense: this.ruleForm.img,
                businessServiceUrl: this.ruleForm.img3,
                id: this.editId,
                // bodyguardVerifyStatus: this.ruleForm.status
              };
              this.$axios
                .post(`/admapi/bodyguard/update`, param)
                .then(({ data }) => {
                  this.$message({
                    message: "编辑成功",
                    type: "success",
                  });
                  this.getDetail();
                  this.pageStatus = 0;
                })
                .catch()
                .finally((this.canConfrim = true));
            }
          } else {
            const reg = /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/;
            if (
              this.ruleForm.idNum == "" ||
              this.ruleForm.sex == "" ||
              this.ruleForm.year == "" ||
              this.ruleForm.address1 == "" ||
              this.ruleForm.high == "" ||
              this.ruleForm.weight == "" ||
              this.ruleForm.certNumber1 == ""
            ) {
              this.$message({
                message: "请填写必填项",
                type: "warning",
              });
              return;
            } else if (reg.test(this.ruleForm.idNum) == false) {
              this.$message({
                message: "请填写正确的身份证号码",
                type: "warning",
              });
              return;
            } else {
              this.canConfrim = false;
              let param = {
                cardCode: this.ruleForm.idNum,
                sex: this.ruleForm.sex,
                birthday: this.ruleForm.year,
                address: this.ruleForm.address1,
                weight: this.ruleForm.weight,
                high: this.ruleForm.high,
                bodyguardCardCode: this.ruleForm.certNumber1,
                id: this.editId,
              };
              this.$axios
                .post(`/admapi/bodyguard/update`, param)
                .then(({ data }) => {
                  let that = this;
                  that.$message({
                    message: "编辑成功",
                    type: "success",
                  });
                  if (
                    that.ruleForm.img1 != "" ||
                    that.ruleForm.img2 != "" ||
                    that.ruleForm.certFrontUrl != ""
                  ) {
                    if (that.ruleForm.img1 != "" && that.ruleForm.img2 != "") {
                      that.confrimId();
                    }
                    if (that.ruleForm.certFrontUrl != "") {
                      that.confrimCard();
                    }
                    that.getDetail();
                    that.pageStatus = 0;
                  } else {
                    that.getDetail();
                    that.pageStatus = 0;
                    that.canConfrim = true;
                  }
                })
                .catch()
                .finally((this.canConfrim = true));
            }
          }
        }
      }
    },
    confrimId() {
      let param = {
        cardBackUrl: this.ruleForm.img2,
        cardFrontUrl: this.ruleForm.img1,
        cardCode: this.ruleForm.idNum,
        id: this.editId,
      };
      this.$axios
        .post(`/admapi/bodyguard/cardupdate`, param)
        .then(({ data }) => {})
        .catch()
        .finally((this.canConfrim = true));
    },
    confrimCard() {
      let param = {
        bodyguardCerts: [
          {
            certFrontUrl: this.ruleForm.certFrontUrl,
            certNumber: this.ruleForm.certNumber1,
          },
        ],
        id: this.editId,
      };
      if (this.detail.bodyguardCerts.length != 0) {
        param.bodyguardCerts[0].id = this.detail.bodyguardCerts[0].id;
      }
      this.$axios
        .post(`/admapi/bodyguard/certupdate`, param)
        .then(({ data }) => {})
        .catch()
        .finally((this.canConfrim = true));
    },
    getDetail() {
      this.$axios
        .post(`/admapi/bodyguard/get/${this.editId}`, { id: this.editId })
        .then(({ data }) => {
          if (data.birthday && data.birthday != "") {
            let val = data.birthday;
            let val1 = val.substr(0, 4) * 1;
            this.age = this.year - val1;
          }
          this.detail = data;
          this.ruleForm.num = data.licenseNo || "";
          this.ruleForm.address = data.registerAddress || "";
          this.ruleForm.name = data.corporateName || "";
          this.ruleForm.num1 = data.taxNo || "";
          this.ruleForm.img = data.businessLicense || "";
          this.ruleForm.img3 = data.guardLicenseUrl || "";
          this.ruleForm.idNum = data.cardCode || "";
          this.ruleForm.sex = data.sex.toString() || "";
          this.ruleForm.year = data.birthday || "";
          this.ruleForm.address1 = data.address || "";
          this.ruleForm.high = data.high == 0 ? "" : data.high;
          this.ruleForm.weight = data.weight == 0 ? "" : data.weight;
          this.ruleForm.bodyguardCardCode = data.bodyguardCardCode || "";
          this.ruleForm.img1 = data.cardFrontUrl || "";
          this.ruleForm.img2 = data.cardBackUrl || "";
          this.ruleForm.bodyguardCard = data.bodyguardCard || "";
          this.ruleForm.certFrontUrl =
            data.bodyguardCerts && data.bodyguardCerts.length > 0
              ? data.bodyguardCerts[0].certFrontUrl
              : "";
          this.ruleForm.certNumber =
            data.bodyguardCerts && data.bodyguardCerts.length > 0
              ? data.bodyguardCerts[0].certNumber
              : "";
          this.ruleForm.certNumber1 =
            data.bodyguardCerts && data.bodyguardCerts.length > 0
              ? data.bodyguardCerts[0].certNumber
              : "";
          console.log(this.ruleForm.sex.toString());
        })
        .catch()
        .finally();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getlist();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getlist();
    },
    getlist() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
      };
      let url = "";
      //   if (this.selectIndex == 1) {
      //   //充值记录
      //   url = "/admapi/bodyguard/rechargelist";
      //   param.bodyguardId = this.editId;
      // }
      if (this.selectIndex == 0) {
        //任务记录
        url = "/admapi/bodyguard/joblist";
        param.bodyguardId = this.editId;
      } else if (this.selectIndex == 1) {
        //违约记录
        url = "/admapi/bodyguard/violationlist";
        param.bodyguardId = this.editId;
      }
      //  else if (this.selectIndex == 2) {
      //   //登录记录
      //   param.bodyguardId = this.editId;
      //   url = "/admapi/bodyguard/loginlist";
      // }
      else if (this.selectIndex == 2) {
        //钱包明细
        param.bodyguardId = this.editId;
        url = "/admapi/bodyguard/billdetaillist";
      } else {
        //绑定银行卡
        param.bodyguardId = this.editId;
        url = "/admapi/bodyguard/banklist";
      }
      this.$axios
        .post(url, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    handleClick(tab) {
      this.selectIndex = tab.index;
      this.pageSize = 10;
      this.page = 1;
      this.getlist();
    },
    addTag() {
      this.getTag();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    confrimTag() {
      let arr = [];
      for (var i = 0; i < this.tagsList.length; i++) {
        if (this.tagsList[i].isSelect == "1") {
          arr.push(this.tagsList[i].id);
        }
      }
      let param = {
        id: this.editId,
        tagIdList: arr,
      };
      this.$axios
        .post(`/admapi/custom/updatetag/${this.editId}`, param)
        .then(({ data }) => {
          this.$message({
            message: "编辑成功",
            type: "success",
          });
          this.dialogVisible = false;
          this.getDetail1();
        })
        .catch()
        .finally();
    },
    getTag() {
      let param = {
        page: 1,
        pageSize: 10000,
      };
      this.$axios
        .post("/admapi/tag/availabllist", param)
        .then(({ data }) => {
          let arr = data.items;
          let arr1 = this.detail.tagsList;
          if (arr1.length > 0) {
            for (var i = 0; i < arr.length; i++) {
              for (var v = 0; v < arr1.length; v++) {
                if (arr1[v].id == arr[i].id) {
                  arr[v].isSelect = "1";
                } else {
                  arr[v].isSelect = "0";
                }
              }
            }
          } else {
            for (var v = 0; v < arr.length; v++) {
              arr[v].isSelect = "0";
            }
          }
          this.tagsList = arr;
          this.dialogVisible = true;
        })
        .catch()
        .finally();
    },
    selectTag(val) {
      for (var i = 0; i < this.tagsList.length; i++) {
        if (val.isSelect == "1") {
          this.tagsList[i].isSelect = "0";
        } else {
          this.tagsList[i].isSelect = "1";
        }
      }
    },
  },
};
</script>
<style scoped>
.solidBox {
  /* border: solid 1px #e8e8e8; */
  padding: 10px 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.modelView {
  position: absolute;
  top: 0;
  left: 0px;
  width: 200px;
  height: 200px;
  background: rgb(0, 0, 0, 0.4);
  text-align: center;
  line-height: 200px;
  color: #fff;
}
.modelView1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  height: 100px;
  background: rgb(0, 0, 0, 0.4);
  text-align: center;
  line-height: 100px;
  color: #fff;
}
.modelTitle {
  border-left: solid 5px #165dff;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 22px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
}
.modelDetail {
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
  box-sizing: border-box;
}
.infoItem {
  margin-right: 80px;
  color: #6d6b6b;
  margin-top: 24px;
  display: flex;
  align-items: center;
}
.infoItem img {
  width: 300px;
  height: 200px;
  margin-left: 20px;
}
.tagList {
  display: flex;
  flex-wrap: wrap;
}
.item {
  padding: 4px 10px;
  box-sizing: border-box;
  border: solid #6d6b6b 1px;
  text-align: center;
  line-height: 30px;
  border-radius: 8px;
  margin-right: 20px;
  cursor: pointer;
}
.all {
  color: #165dff;
  border-color: #165dff;
}
.select {
  border: none;
  background: #165dff;
  color: #fff;
}
.avatar {
  width: 150px;
  height: 100px;
}
.el-form-item {
  display: flex;
  align-items: center;
}
</style>
